<script setup lang="ts">
import { ref } from 'vue';
import type { EmptyCallback, ParamsCallback } from '../../utils/global-types';

const requestPending = ref(false);
const props = defineProps<{
    message: string,
    callback?: ParamsCallback,
    close: EmptyCallback
}>();

function confirm() {
    requestPending.value = true
    if (props.callback) {
        props.callback(true)
    }
    props.close()
}
</script>
<template>
    <div class="modal-body">
        <div v-html="message"></div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" @click="confirm" :disabled="requestPending">OK</button>
    </div>
</template>
